import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { catchError, Observable, retry } from 'rxjs';
import { FilterParams, StarbaseDataService } from 'starbase-launcher';
import { WebApiService } from 'starbase-login';
import { StarbaseNotificationService, StarbaseNotificationTypes } from 'starbase-notification';
import { STLog } from 'scaletech-core';

@Injectable({
  providedIn: 'root'
})
export class LogDataService extends StarbaseDataService<STLog> {
  protected _staleDataTimeout: number;
  protected _getOneUri: string;
  protected _getAllUri = '/api/LogModel';
  protected _postUri: string;
  protected _putUri: string;
  protected _deleteUri: string;
  protected _broadSearchUri = '/api/LogModel/GetLogModelsByFilterParams';
  protected _recordHistoryBroadsearchUri = '/api/LogModel/GetRecordHistoryByFilterParams';

  public get recorHistoryBroadsearchUri() {
    return this._recordHistoryBroadsearchUri;
  }

  @Output() recordHistoryOpener = new EventEmitter<FilterParams<STLog>>();

  private _lastRetrievedEntityName = '';

  constructor(private _httpx2: HttpClient, private _webAPIx2: WebApiService, private notiSvc: StarbaseNotificationService) {
    super(_httpx2, _webAPIx2);
  }

  getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<STLog>): Observable<FilterParams<STLog>> {
    filterParams.collection = [];
    return this._httpx2.post<FilterParams<STLog>>(this.server + url, filterParams, {
      headers: this._webAPIx2.getApiHeaders('post')}).pipe(
        retry(this.defaultRetries),
        catchError(e => this._webAPIx2.handleRequestError(e))
      );
  }

  getRecordHistoryData(guid: string): void {
    if (!guid || guid === '') {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Unknown entity',
          'Sorry, record history is not available for that entity.',
          StarbaseNotificationTypes.Notice
        )
      );
      return;
    }
    const fp = new FilterParams<STLog>();
    fp.rpp = 10;
    fp.addToFilter('EntityGuid', guid);
    this.getDataByFilterParamsBroadSearch(this._broadSearchUri, fp).subscribe(d => {
      this._lastRetrievedEntityName = (d.collection.length) ? d.collection[0].entityName : '';
      this.recordHistoryOpener.emit(d);
    });
  }
  public get lastRetrievedEntityName(): string { return this._lastRetrievedEntityName; }

  public setLastRetrievedEntityName(val: string) { this._lastRetrievedEntityName = val; }

}
